﻿window.cObjetEmailListeNoireMetier = function(objet) {
    var Me = this;
    this.data = objet.data;
    this.objet = objet;

    this.mGetLibBase = function () { return "email désinscription"; }
    this.mGetAttributBase = function () { return "le " }
    this.mGetNewLib = function () { return "Nouvelle désinscription"; }
    this.mGetLib1 = function (option) {
        var txt = ""
        if (typeof objet.data != 'undefined') {
            txt = objet.data.adresse_email
        } else {
            txt = "désinscription"
        }
        if (typeof option !='undefined' && typeof option.callBack != 'undefined') { option.callBack(txt) }
        else { return txt }
    }
    this.mGetLib2 = function () {
        return ""
    }

    this.mGetRadiusImage = function () { return "5px" }

    this.mGetIcone = function (dataTemplate) {
        return $("<i class='fas fa-user-secret' title='Email désinscriptions'></i>");
    }

    this.contentTemplateGrid = function (contentElement, option) {
        contentElement.empty();

    }

    this.contentTemplatePopup = function (contentElement, option) {

    }

    //this.itemTemplateVirtualGridFixed = function (contentElement, option) {
    //    contentElement.empty()
    //    if (typeof option == "undefined") option = {}
    //    if (typeof option.height == 'undefined') option.height = 70
    //    contentElement.css({ position: "relative" })

    //    Me.objet.bddRef.mAjaxCall({
    //        command: "getlstcontactfromemail",
    //        adresse_email: objet.data.adresse_email
    //    }, function (data) {
    //        if (typeof data.lstcontact == 'undefined') data.lstcontact = []
    //        var opt = {
    //            bddCtrl: Me.objet.bddRef,
    //            size: option.height / 3 * 2 - 3, onClick: null, allowClick: false
    //        }
    //        if (data.lstcontact.length == 1) {
    //            opt.id_table = data.lstcontact[0].id_table
    //            opt.id = data.lstcontact[0].id
    //        } else {
    //            opt.nb = data.lstcontact.length
    //            opt.icone = "fas fa-user-secret"
    //            opt.txtooltip = "%%nb%% contacts"
    //        }
    //        if (typeof option.onClickImage != 'undefined') { opt.onClick = option.onClickImage }
    //        else if (data.lstcontact.length > 0) {
    //            opt.onClick = function () {
    //                if (data.lstcontact.length == 1) {
    //                    var nomTable = Me.objet.bddRef.table.mGetItem(data.lstcontact[0].id_table).nom
    //                    Me.objet.bddRef.getObjet(nomTable, data.lstcontact[0].id).mShowPopup()
    //                } else {
    //                    var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
    //                        target: dxImageObjet.element(),
    //                        width: 300,
    //                        contentTemplate: function (contentElement) {
    //                            contentElement.css("padding", "25px")
    //                            contentElement.css("text-align", "left")
    //                            var $Table = $("<table style='width:100%;table-layout: fixed;'/>").appendTo(contentElement)
    //                            data.lstcontact.forEach(function (cont) {
    //                                var nomTable = Me.objet.bddRef.table.mGetItem(cont.id_table).nom
    //                                var obj = Me.objet.bddRef.getObjet(nomTable, cont.id)
    //                                var $Tr = $("<tr class='state-hover'/>").appendTo($Table)
    //                                var $Td = $("<td style='width:20px;padding:5px;'/>").appendTo($Tr)
    //                                obj.mGetIcone().appendTo($Td)
    //                                var $Td = $("<td style='overflow-x:hidden;text-overflow:ellipsis;width:100%;padding:5px;'>" + obj.mGetLib1() + "</td>").appendTo($Tr)
    //                                $Tr.on("click", function (e) {
    //                                    e.stopPropagation()
    //                                    obj.mShowPopup()
    //                                    tt.hide()
    //                                })
    //                            })
    //                        }
    //                    }).dxCtrlTooltip("instance")
    //                    tt.show();
    //                }
    //            }
    //        }
    //        var dxImageObjet = $("<div style='position:absolute;top:0;left:0;' class='state-hover2'/>").appendTo(contentElement).dxCtrlImageData(opt).dxCtrlImageData("instance")

    //        if (data.lstcontact.length == 0) {
    //            $DivSujet.html("(aucun contact)")
    //        } else if (data.lstcontact.length == 1) {
    //            var nomTable = Me.objet.bddRef.table.mGetItem(data.lstcontact[0].id_table).nom
    //            $DivSujet.html(Me.objet.bddRef.getObjet(nomTable, data.lstcontact[0].id).mGetLib1())
    //        } else { $DivSujet.html(data.lstcontact.length + " contacts") }
    //    });

    //    var $Div = $("<div style='width:calc(100% - " + (option.height / 3 * 2 + 10) + "px);position:absolute;top:0;left:" + (option.height / 3 * 2 + 10) + "px;' class='divtext'></div>").appendTo(contentElement)
    //    var $DivSujet = $("<div style='white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:100%;opacity:0.6;'></div>").appendTo($Div)
    //    var $DivDest = $("<div style='overflow-x:hidden;text-overflow:ellipsis;font-size:80%;opacity:0.5;'>" + objet.data.adresse_email + "</div>").appendTo($Div)
    //    if (contentElement.closest(".awsm-timeline-content").length > 0) {
    //        $("<div style='position:absolute;font-size:80%;opacity:0.5;bottom:1px;left:2px;' title='" + objet.data.dcr.toFrenchDateTime() + "'>Créé " + objet.data.dcr.toDateIlya(true) + "</div>").appendTo(contentElement.parent().parent().parent().parent().parent());
    //    }
    //}
    //this.itemTemplateVirtualGridFixedLigne = function (contentElement, option) {
    //    contentElement.empty()
    //    if (typeof option == "undefined") option = {}
    //    if (typeof option.height == 'undefined') option.height = 30
    //    contentElement.css({ position: "relative" })
    //    contentElement.css({ "text-align": "left" })

    //    Me.objet.bddRef.mAjaxCall({
    //        command: "getlstcontactfromemail",
    //        adresse_email: objet.data.adresse_email
    //    }, function (data) {
    //        if (typeof data.lstcontact == 'undefined') data.lstcontact = []
    //        var opt = {
    //            bddCtrl: Me.objet.bddRef,
    //            size: 20, onClick: null, allowClick: false
    //        }
    //        if (data.lstcontact.length == 1) {
    //            opt.id_table = data.lstcontact[0].id_table
    //            opt.id = data.lstcontact[0].id
    //        } else {
    //            opt.nb = data.lstcontact.length
    //            opt.icone = "fas fa-user-secret"
    //            opt.txtooltip = "%%nb%% contacts"
    //        }
    //        if (typeof option.onClickImage != 'undefined') { opt.onClick = option.onClickImage }
    //        else if (data.lstcontact.length > 0) {
    //            opt.onClick = function () {
    //                if (data.lstcontact.length == 1) {
    //                    var nomTable = Me.objet.bddRef.table.mGetItem(data.lstcontact[0].id_table).nom
    //                    Me.objet.bddRef.getObjet(nomTable, data.lstcontact[0].id).mShowPopup()
    //                } else {
    //                    var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
    //                        target: dxImageObjet.element(),
    //                        width: 300,
    //                        contentTemplate: function (contentElement) {
    //                            contentElement.css("padding", "25px")
    //                            contentElement.css("text-align", "left")
    //                            var $Table = $("<table style='width:100%;table-layout: fixed;'/>").appendTo(contentElement)
    //                            data.lstcontact.forEach(function (cont) {
    //                                var nomTable = Me.objet.bddRef.table.mGetItem(cont.id_table).nom
    //                                var obj = Me.objet.bddRef.getObjet(nomTable, cont.id)
    //                                var $Tr = $("<tr class='state-hover'/>").appendTo($Table)
    //                                var $Td = $("<td style='width:20px;padding:5px;'/>").appendTo($Tr)
    //                                obj.mGetIcone().appendTo($Td)
    //                                var $Td = $("<td style='overflow-x:hidden;text-overflow:ellipsis;width:100%;padding:5px;'>" + obj.mGetLib1() + "</td>").appendTo($Tr)
    //                                $Tr.on("click", function (e) {
    //                                    e.stopPropagation()
    //                                    obj.mShowPopup()
    //                                    tt.hide()
    //                                })
    //                            })
    //                        }
    //                    }).dxCtrlTooltip("instance")
    //                    tt.show();
    //                }
    //            }
    //        }
    //        var dxImageObjet = $("<div style='position:absolute;top:0;left:0;' class='" + ((data.lstcontact.length == 0) ? "" : "state-hover2") + "'/>").appendTo($TdImageExp).dxCtrlImageData(opt).dxCtrlImageData("instance")

    //        if (data.lstcontact.length == 0) {
    //            $TdDest.html("(aucun contact)")
    //        } else if (data.lstcontact.length == 1) {
    //            var nomTable = Me.objet.bddRef.table.mGetItem(data.lstcontact[0].id_table).nom
    //            $TdDest.html(Me.objet.bddRef.getObjet(nomTable, data.lstcontact[0].id).mGetLib1())
    //        } else { $TdDest.html(data.lstcontact.length + " contacts") }
    //    });


    //    var $Table = $("<table style='width:100%;table-layout: fixed;'/>").appendTo(contentElement)
    //    var $Tr = $("<tr style='white-space:nowrap;'/>").appendTo($Table)
    //    var $TdImageExp = $("<td style='width:22px'/>").appendTo($Tr)

    //    var $TdDest = $("<td style='width:30%;font-variant:small-caps;font-weight:bold;overflow-x:hidden;text-overflow:ellipsis;'></td>").appendTo($Tr)
    //    var $TdEmail = $("<td style='width:70%;font-style: italic;font-weight:bold;opacity:0.3;overflow-x:hidden;text-overflow:ellipsis;font-size:80%;'>" + objet.data.adresse_email + "</span></td>").appendTo($Tr)
    //}

    this.hasScrollPopup = function () { return false }
    this.isPopupFullScreen = false
    //this.mShowPopup = function (optionPopup) {
    //    page.mAddPopup(objet.data)
    //}

}